import React, { useEffect, useState } from "react";
import "./CV.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import crown from "assets/crown.png";
import {
  FaRegBookmark,
  FaBookmark,
  FaPaperclip,
  FaShoppingBag,
} from "react-icons/fa";
import Modal from "Components/Modal/Modal";
// import laurier_alumnis from "assets/laurier.webp";
import CVPaniers from "../CVPaniers/CVPaniers";
import { updateCVs } from "Redux/Actions/cvsActions";
import axios from "axios";
import { Link } from "react-router-dom";
import { updateAuth } from "Redux/Actions/authActions";
import Loader from "Components/Loader/loader";
import { truncate } from "Services/functions";
import neutralUser from "assets/neutralUser.png";
import { useIntersectionObserver } from "Services/intersectionObserver";

const CV = (props) => {
  const [intersectionRef, isVisibleIntersection] = useIntersectionObserver();
  const [bookmark, setBookmark] = useState(
    props.auth.userConnected.savedResumes.some(
      (resume) => resume.id === props.resumeId
    )
  );

  // Quand on quitte la page CVThèque on réinitialise le fait de venir du bouton "ajouter des CVs" de l'onglet panier de CV
  useEffect(() => {
    return () => {
      props.handleUpdateCVs({
        isAddedFromBasket: false,
        fromBasketId: null,
      });
    };
  }, []);

  // Fonction qui réinitialise les variables globales quand on ferme la pop-up des paniers de CV en cliquant sur la croix
  const closePopBasket = () => {
    props.handleUpdateCVs({
      addedResumeId: null,
      isAddedResume: false,
      visibleModalPanier: false,
    });
  };

  // Quand on ne vient pas d'un panier en particulier: Hook qui déclenche un toast de succès quand le CV est ajouté au panier
  useEffect(() => {
    if (!props.cvs.isAddedResume && props.cvs.visibleModalPanier) {
      props.uploadToast.current.show({
        severity: "success",
        summary: "Succès : ",
        detail: "Le CV a bien été ajouté",
        life: 3000,
      });
      props.handleUpdateCVs({
        visibleModalPanier: false,
      });
    }
  }, [props.cvs.isAddedResume]);

  //  Quand on vient d'un panier en particulier: ajoute le CV au panier
  const addResume = (id, basketId) => {
    // Liste des CV déjà dans le panier
    const newBasketResumeItems = props.cvs.cvsBasket.filter(
      (basket) => basket.id === basketId
    )[0].basketResumeItems;

    // Variable qui détermine si le panier contient déjà ce CV
    const isContaining = newBasketResumeItems.some(
      (basketResume) => basketResume.resume.id === id
    );

    // Si le panier contient le CV: toast d'erreur
    if (isContaining) {
      props.cancelToast.current.show({
        severity: "error",
        summary: "error : ",
        detail: "Le panier contient déjà ce CV",
        life: 3000,
      });
      // Sinon ferme la fenêtre et ajoute le CV au panier dans l'API
    } else {
      // URL de la requête POST
      let url = `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/${basketId}/add_resumes`;
      const data = [`/api/cvs/${id}`];
      axios
        .post(url, data, {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        })
        .then((res) => {
          props.handleUpdateCVs({
            cvsBasket: props.cvs.cvsBasket.map((basket) => {
              if (basket.id === basketId) return res.data;
              else return basket;
            }),
          });
        })
        .catch((error) => {
          props.auth.toast?.current?.show({
            severity: "error",
            summary: "Erreur",
            detail: error?.response?.data?.detail || "Une erreur est survenue",
            life: 5000,
          });
        })
        .finally(
          props?.uploadToast?.current.show({
            severity: "success",
            summary: "Succès : ",
            detail: "Le CV a bien été ajouté",
            life: 3000,
          })
        );
    }
  };
  const [isLoader, setIsLoader] = useState(false);
  const addResumeToSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${props.resumeId}/save`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    setIsLoader(true);
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        setIsLoader(false);
        let user = props.auth.userConnected;
        user.savedResumes = user.savedResumes.concat([res.data]);
        props.handleAuth({
          userConnected: user,
        });
        props.uploadToast.current.show({
          severity: "success",
          summary: "Succès : ",
          detail: "Le CV a bien été ajouté aux CV sauvegardés",
          life: 3000,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };
  const removeResumeFromSaveList = () => {
    const url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${props.resumeId}/erase`;
    const data = { savedByUsers: [`api/users/${props.auth.userConnected.id}`] };
    setIsLoader(true);
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        setIsLoader(false);
        let user = props.auth.userConnected;
        user.savedResumes = user.savedResumes.filter(
          (saved) => saved.id !== res.data.id
        );
        props.handleAuth({
          userConnected: user,
        });
        props.cancelToast.current.show({
          severity: "error",
          summary: "succès : ",
          detail: "Le CV a bien été retiré de la liste des CV sauvegardés",
          life: 3000,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  const downloadRPResume = () => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/cvs/${props.resumeId}/pdf`;
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${props.auth.token}`,
          accept: "application/json",
        },
        responseType: "blob",
      })
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res.data);
        link.setAttribute(
          "download",
          `CV_ReseauPro_${props.firstname}_${props.surname}`
        );
        link.click();
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  return (
    <div
      className={
        props.displayFromBasket
          ? "CV__container cardHover from_basket"
          : "CV__container cardHover from_cv"
      }
      ref={intersectionRef}
    >
      <div className="CV">
        <div className="CV__image">
          {/* <div className="user__alumnis">
            {props.roles.some((role) => role.roleName == "ROLE_ALUMNI") && (
              <img
                src={laurier_alumnis}
                alt="Laurier alumni"
                title="Laurier alumni"
              />
            )}
          </div> */}
          {isVisibleIntersection && (
            <img
              src={props.imageUrl ? props.imageUrl : neutralUser}
              alt="Mon avatar"
              title="Mon avatar"
              loading="lazy"
            />
          )}
        </div>
        <div className="details">
          <div className="left">
            <h2 className="h2_name">
              {`${props.firstname} ${props.surname}`}
              {props.certified && <img src={crown} alt="couronne" />}
            </h2>
            <h3 className="h3_poste">{truncate(props.titre, 22)} </h3>
            <div className="bottom">
              <Link
                to={{
                  pathname: `/profil-show/${props.userId}`,
                  params: props.userId,
                }}
                title={`Voir le profil de l'étudiant ${props.firstname} ${props.surname}`}
              >
                <a href="" className="show_profil">
                  {" "}
                  Voir le profil
                </a>
              </Link>
              <div
                className="dwnld_cv"
                onClick={() => {
                  downloadRPResume();
                }}
              >
                {" "}
                <FaPaperclip />
                Télécharger le CV
              </div>
            </div>
          </div>
          <div className="right">
            <div className="flag_save">
              {!isLoader ? (
                bookmark ? (
                  <div className="tooltip">
                    <FaBookmark
                      onClick={() => {
                        setBookmark(!bookmark);
                        removeResumeFromSaveList();
                      }}
                    />
                    <span className="tooltiptext">
                      Enlever ce CV des CV sauvegardés
                    </span>
                  </div>
                ) : (
                  <div className="tooltip">
                    <span className="tooltiptext">Sauvegarder ce CV</span>
                    <FaRegBookmark
                      onClick={() => {
                        setBookmark(!bookmark);
                        addResumeToSaveList();
                      }}
                    />
                  </div>
                )
              ) : (
                <Loader></Loader>
              )}
            </div>
            <div>
              <div className="tooltip">
                {!props.displayFromBasket && ( // Si on appelle le composant CV pour afficher les CV contenu dans un panier on n'affiche pas l'icone
                  <FaShoppingBag
                    data-testid="basketIcon"
                    // Au click sur l'icone on change les variables globales pour ouvrir une pop-up avec les paniers de CV
                    onClick={() => {
                      if (props.auth.isConnected && props.auth.isAdmin) {
                        // Si on ouvre la CVThèque depuis panier de CV, au clic ajoute le CV dans le panier, sinon ouvre une pop-up pour choisir le panier
                        if (props.cvs.isAddedFromBasket) {
                          addResume(props.resumeId, props.cvs.fromBasketId);
                        } else {
                          props.handleUpdateCVs({
                            addedResumeId: props.resumeId,
                            isAddedResume: true,
                            visibleModalPanier: true,
                          });
                        }
                      }
                    }}
                  />
                )}

                <span className="tooltiptext">
                  {props.cvs.isAddedFromBasket
                    ? "Ajouter ce CV dans le panier"
                    : "Ajouter ce CV dans un panier"}
                </span>
              </div>
            </div>
          </div>
        </div>
        {/* Si le shopping bag est cliqué et que le panier n'est pas connu, ouvre une fenetre avec les paniers de CV */}
        {props.cvs.visibleModalPanier && (
          <Modal
            visible={props.cvs.visibleModalPanier}
            setVisible={closePopBasket}
            header={`Ajoutez ce CV à un panier`}
          >
            <div className="CV_panier_modal">
              <CVPaniers
                activeIndex={props.items.itemsCVTheque.findIndex(
                  (index) => index.label == "Paniers de cv"
                )}
                items={props.items.itemsCVTheque}
              />
            </div>
          </Modal>
        )}
      </div>
    </div>
  );
};

CV.propTypes = {
  firstname: PropTypes.string,
  surname: PropTypes.string,
  prenom: PropTypes.string,
  titre: PropTypes.string,
  bookmark: PropTypes.bool,
  date: PropTypes.string,
  // alumni: PropTypes.bool,
  // crown: PropTypes.bool,
  items: PropTypes.object,
  key: PropTypes.number,
  userId: PropTypes.number,
  handleUpdateCVs: PropTypes.func,
  cvs: PropTypes.object,
  auth: PropTypes.object,
  educations: PropTypes.array,
  roles: PropTypes.array,
  displayFromBasket: PropTypes.bool,
  resumeId: PropTypes.number,
  handleAuth: PropTypes.func,
  savedResumes: PropTypes.array,
  uploadToast: PropTypes.func,
  cancelToast: PropTypes.func,
  imageUrl: PropTypes.string,
  certified: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  items: state.items,
  cvs: state.cvs,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateCVs: (value) => {
    dispatch(updateCVs(value));
  },
  handleAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CV);
